import FormGroup from '@mui/material/FormGroup';
import styled from 'styled-components';

export const LabelListContainer = styled(FormGroup)`
    max-height: 400px;
    flex-wrap: nowrap;
    overflow-y: scroll;
`;